export const environment = {
	baseUrl: 'https://beltrashow.slajara.com',
	pathBackend: 'https://beltrashow.slajara.com/api/v1',
	production: false,
	// Empty: Sentry stays off in staging (set the DSN here to report staging errors as 'staging')
	sentryDsn: '',
	sentryEnvironment: 'staging',
};
